<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wprowadź PIN
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model.number="pin"
                            v-mask="'####'"
                            label="PIN"
                            type="password"
                            outlined
                        />
                    </v-col>
                </v-row>
            </div>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    name: 'PinConfirmationDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        pinData: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            pin: null
        }
    },
    watch: {
        pin(value) {
            if (value === this.pinData) {
                this.confirmPin()
            }
        }
    },
    methods: {
        confirmPin() {
            this.$emit('confirm-pin')
            setTimeout(() => {
                this.pin = null
            }, 500)
        },
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.pin = null
            }, 500)
        },
    }
}
</script>